module.exports = {
          srcSet: __webpack_public_path__ + "images/1904-2-be580205522e917eeb34e4700789e2de-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1904-2-bbe77d3c7d0e42cbd24301139da7b286-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1904-2-be580205522e917eeb34e4700789e2de-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1904-2-bbe77d3c7d0e42cbd24301139da7b286-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1904-2-be580205522e917eeb34e4700789e2de-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1904-2-be580205522e917eeb34e4700789e2de-320.jpg"},
          
          width: 320,
          height: 251
        }